import React, { FC, useCallback, useState } from 'react';

import { HeaderItem } from '../../types';
import HeaderMenu from '../HeaderMenu';
import { ButtonText, Container, Content } from './styles';

type PropTypes = {
  children: React.ReactNode;
  items?: HeaderItem[];
  mobile?: boolean;
  id: string;
  tabIndex?: number;
  hasModules?: boolean;
};

const NavLink: FC<PropTypes> = ({ children, items = [], mobile = false, id, tabIndex, hasModules = false }) => {
  const [isOpen, setIsOpen] = useState(false);

  const closeMenu = useCallback(() => {
    setIsOpen(false);
  }, []);

  const toggleMenu = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  return (
    <Container className={id}>
      <Content
        type="button"
        data-testid={`nav-link-${id}`}
        data-nav-id={id}
        onClick={toggleMenu}
        className={id}
        tabIndex={tabIndex}
      >
        <ButtonText data-testid={`nav-link-${id}-span`} className={id} isOpen={isOpen}>
          {children}
        </ButtonText>
      </Content>
      <HeaderMenu
        className={id}
        hasModules={hasModules}
        id={id}
        mobile={mobile}
        open={isOpen}
        items={items}
        onClose={closeMenu}
      />
    </Container>
  );
};

export default NavLink;
